import { Link } from "react-router-dom";
import { Database, Globe, Users, Telescope, ArrowRight } from "lucide-react";

export default function About() {
    return (
        <div className="ok-container py-12 max-w-4xl mx-auto" data-testid="about-page">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--ok-accent)]">About</div>
            <h1 className="font-display text-4xl sm:text-5xl mt-2 leading-tight">
                We don't tell stories. <br />We archive the truth.
            </h1>
            <p className="opacity-80 text-base mt-6 leading-relaxed max-w-3xl">
                UNVEILED is a living archive of humanity's encounters with the unknown: UFO sightings, UAP, abductions,
                non-human intelligence, interdimensional contact, astral encounters, dreams, missing time and high-strangeness reports.
            </p>
            <p className="opacity-80 text-base mt-4 leading-relaxed max-w-3xl">
                Our mission is to preserve every known encounter from history and let new encounters be logged,
                discussed, analyzed and connected, so humanity can collectively discover the patterns that have
                been hidden in plain sight for decades.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-12">
                <Pillar icon={Database} title="Archive every encounter" desc="From the 1561 Nuremberg event to last week's sighting in Las Vegas. Every report becomes a data point." />
                <Pillar icon={Globe} title="Discover the pattern" desc="Tag, geolocate, timeline and link encounters across time and space. The map of the unknown becomes visible." />
                <Pillar icon={Users} title="Community-driven, not theory-driven" desc="We don't claim truth. The community votes on evidence. The Evidence Index is transparent and the data is open." />
                <Pillar icon={Telescope} title="Witnesses are the heroes" desc="Every report deserves to be heard, indexed and connected. Anonymously if needed. Forever, if you want it preserved." />
            </div>

            <div className="ok-card p-8 mt-12">
                <div className="font-mono text-[10px] uppercase tracking-widest text-[var(--ok-accent)]">Get involved</div>
                <h2 className="font-display text-2xl mt-2">Three ways to contribute</h2>
                <ul className="text-sm opacity-90 mt-4 space-y-2 leading-relaxed">
                    <li>• <strong>Lodge your own encounter</strong>. Every witness matters. <Link to="/lodge" className="ok-link">Submit a report →</Link></li>
                    <li>• <strong>Verify the archive</strong>. Rate Evidence Index, comment, propose connections.</li>
                    <li>• <strong>Become a Founding Witness</strong>. Support the build, lock in lifetime pricing. <Link to="/pricing" className="ok-link">See plans →</Link></li>
                </ul>
            </div>

            <div className="ok-card p-6 mt-6 flex items-center gap-4">
                <div className="flex-1">
                    <div className="font-mono text-[10px] uppercase tracking-widest opacity-50">Get in touch</div>
                    <div className="font-display text-lg">Tips, press, research, partnerships</div>
                </div>
                <Link to="/contact" className="ok-btn-primary" data-testid="about-contact-btn">
                    Contact us <ArrowRight className="w-4 h-4" />
                </Link>
            </div>

            <div className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] opacity-60" data-testid="about-release-date">
                Official site release: June 2026
            </div>
        </div>
    );
}

function Pillar({ icon: Icon, title, desc }) {
    return (
        <div className="ok-card p-6">
            <Icon className="w-6 h-6 text-[var(--ok-accent)]" />
            <h3 className="font-display text-lg mt-3">{title}</h3>
            <p className="text-sm opacity-70 mt-2 leading-relaxed">{desc}</p>
        </div>
    );
}
